export default __webpack_public_path__ + "static/title_right_decor_2-cad4e7a6f8ae15826f8c6cd0b916a418.png";